module.exports = __webpack_public_path__ + "static/media/27.dd1856b2.jpg";